module.exports = __webpack_public_path__ + "img/algebra_1.b54fecf0.svg";